import { Controller } from '@hotwired/stimulus'

// Progressive enhancement for photos-required questions: keep the submit button
// disabled until at least one photo has been attached, and — because a disabled
// button swallows clicks — give feedback when the customer clicks it anyway by
// flashing the photo dropzone and showing a hint. The server still enforces the
// requirement (ItemQuestion#validate_required_photos) for non-JS submits.
export default class extends Controller {
  static targets = ['submit', 'asset', 'dropzone', 'hint']
  static values = { required: Boolean }

  connect () {
    this.refresh()
  }

  // Stimulus fires these as the asset thumbnails are added/removed when the
  // asset manager re-renders over Turbo after an upload or delete.
  assetTargetConnected () {
    this.refresh()
  }

  assetTargetDisconnected () {
    this.refresh()
  }

  refresh () {
    if (!this.requiredValue || !this.hasSubmitTarget) return

    const locked = this.assetTargets.length < 1
    this.submitTarget.disabled = locked
    if (!locked) this.hideHint()
  }

  // Fired from the wrapper around the submit button. A disabled button has
  // pointer-events: none, so the click lands on the wrapper instead.
  guard () {
    if (!this.requiredValue || !this.hasSubmitTarget) return
    if (!this.submitTarget.disabled) return

    this.flashDropzone()
    this.showHint()
  }

  flashDropzone () {
    if (!this.hasDropzoneTarget) return

    const el = this.dropzoneTarget
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    el.classList.add('ring-2', 'ring-red-400', 'ring-offset-2', 'animate-pulse')
    setTimeout(() => {
      el.classList.remove('ring-2', 'ring-red-400', 'ring-offset-2', 'animate-pulse')
    }, 1500)
  }

  showHint () {
    if (this.hasHintTarget) this.hintTarget.classList.remove('hidden')
  }

  hideHint () {
    if (this.hasHintTarget) this.hintTarget.classList.add('hidden')
  }
}
